var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDefaultAvatarH = function SvgDefaultAvatarH(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "default-avatar_h_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 80 80",
    style: {
      enableBackground: "new 0 0 80 80"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".default-avatar_h_svg__st0{fill:none}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.1 55.3c3.8 0 6.1-.4 6.1-1.6 0-.9-1-1.2-3-1.3-.5-.2-.7-2.2-.7-4.5V32.5c0-2.4.2-4.4.7-4.6 2.1-.1 3-.4 3-1.3 0-1.2-2.2-1.6-6.1-1.6-3.9 0-6.2.4-6.2 1.6 0 .9 1 1.2 3 1.3.5.2.7 2.2.7 4.6V38c-.2.5-.4.5-1.5.5H34c-1.1 0-1.3-.1-1.5-.5v-5.5c0-2.4.2-4.4.7-4.6 2.1-.1 3-.4 3-1.3 0-1.2-2.3-1.6-6.2-1.6-3.9 0-6.1.4-6.1 1.6 0 .9.9 1.2 3 1.3.5.2.6 2.2.6 4.6v15.4c0 2.4-.1 4.4-.6 4.5-2.1.1-3 .4-3 1.3 0 1.2 2.3 1.6 6.1 1.6 3.9 0 6.2-.4 6.2-1.6 0-.9-.9-1.2-3-1.3-.5-.2-.7-2.2-.7-4.5v-6c.2-.4.4-.5 1.5-.5h12c1.1 0 1.3.1 1.5.5v6c0 2.4-.2 4.4-.7 4.5-2.1.1-3 .4-3 1.3 0 1.2 2.3 1.6 6.3 1.6z"
  })));
};
export default SvgDefaultAvatarH;